<div title="Agregar filtros al listado">
  <button mat-button class="c-btn-link" (click)="openModal($event)">
    <i class="fas fa-filter"></i>
    {{'Añadir filtro' | t }}
  </button>
</div>
